import store from '../store'
import * as actions from '../actions'
import util from '../util'
import Renderer from '../canvas/renderer'
import "antd/lib/switch/style/index.css";
import { Switch } from "antd";
import constants from '../constants';


export default function AsideVideoAdjusts() {

  function updateBrightness(ev: any) {
    const val = ev.target.value;
    const $elem = util.getElementContent(store.getState().$element);

    Renderer.updateElementStyle($elem, 'filter',
      `brightness(${val * 2}%) 
       contrast(${store.getState().contrast}%) 
       saturate(${store.getState().saturation}%)
       blur(${store.getState().blur}px)
       ${getEffects()}`);

    store.dispatch(actions.updateElementAttribute('brightness', val * 2));
  }

  function updateContrast(ev: any) {
    const val = ev.target.value;
    const $elem = util.getElementContent(store.getState().$element);

    Renderer.updateElementStyle($elem, 'filter',
      `brightness(${store.getState().brightness}%) 
       contrast(${val * 2}%) 
       saturate(${store.getState().saturation}%)
       blur(${store.getState().blur}px)
       ${getEffects()}`);

    store.dispatch(actions.updateElementAttribute('contrast', val * 2));
  }

  function updateSaturation(ev: any) {
    const val = ev.target.value;
    const $elem = util.getElementContent(store.getState().$element);

    Renderer.updateElementStyle($elem, 'filter',
      `brightness(${store.getState().brightness}%) 
       contrast(${store.getState().contrast}%) 
       saturate(${val * 2}%)
       blur(${store.getState().blur}px)
       ${getEffects()}`);

    store.dispatch(actions.updateElementAttribute('saturation', val * 2));
  }

  function updateBlur(ev: any) {
    const val = ev.target.value;
    const $elem = util.getElementContent(store.getState().$element);

    Renderer.updateElementStyle($elem, 'filter',
      `brightness(${store.getState().brightness}%) 
       contrast(${store.getState().contrast}%) 
       saturate(${store.getState().saturation}%)
       blur(${val / 10}px)
       ${getEffects()}`);

    store.dispatch(actions.updateElementAttribute('blur', val / 10));
  }

  function updateOpacity(ev: any) {
    const val = ev.target.value;
    const $elem = util.getElementContent(store.getState().$element);

    Renderer.updateElementStyle($elem, 'opacity', val / 100);
    store.dispatch(actions.updateElementAttribute('opacity', val));
  }

  function getEffects() {
    return `
      grayscale(${store.getState().grayscale}) 
      sepia(${store.getState().sepia}) 
      invert(${store.getState().invert})
    `
  }

  function getAdjusts() {
    return `
      brightness(${store.getState().brightness}%) 
      contrast(${store.getState().contrast}%) 
      saturate(${store.getState().saturation}%)
      blur(${store.getState().blur}px)
    `
  }

  function toggleGrayscale(checked: boolean) {
    const $elem = util.getElementContent(store.getState().$element);

    Renderer.updateElementStyle($elem, 'filter', `
        ${getAdjusts()}
        grayscale(${checked ? 1 : 0})
        sepia(${store.getState().sepia})
        invert(${store.getState().invert})
      `);

    store.dispatch(actions.updateElementAttribute('grayscale', checked ? 1 : 0));
  }

  function toggleSepia(checked: boolean) {
    const $elem = util.getElementContent(store.getState().$element);

    Renderer.updateElementStyle($elem, 'filter', `
        ${getAdjusts()}
        grayscale(${store.getState().grayscale})
        sepia(${checked ? 1 : 0})
        invert(${store.getState().invert})
      `);

    store.dispatch(actions.updateElementAttribute('sepia', checked ? 1 : 0));
  }

  function toggleInvert(checked: boolean) {
    const $elem = util.getElementContent(store.getState().$element);

    Renderer.updateElementStyle($elem, 'filter', `
        ${getAdjusts()}
        grayscale(${store.getState().grayscale})
        sepia(${store.getState().sepia})
        invert(${checked ? 1 : 0})
      `);

    store.dispatch(actions.updateElementAttribute('invert', checked ? 1 : 0));
  }

  function resetAnimation() {
    const $elem = util.getElementContent(store.getState().$element);
    Renderer.updateElementStyle($elem, 'animation', '');
    store.dispatch(actions.updateElementAttribute('animation', ''));
  }

  function rise() {
    resetAnimation();
    const $elem = util.getElementContent(store.getState().$element);

    let duration = 1;

    util.createAnimation($elem, 'slide-to-bottom')

    const animation = `slide-to-bottom_${$elem[0].id} ${duration}s cubic-bezier(0.190, 1.000, 0.220, 1.000) both infinite`

    Renderer.updateElementStyle($elem, 'animation', animation);
    store.dispatch(actions.updateElementAttribute('animation', animation));
  }

  function pan() {
    resetAnimation();
    const $elem = util.getElementContent(store.getState().$element);

    let duration = 1;

    util.createAnimation($elem, 'slide-to-right')

    const animation = `slide-to-right_${$elem[0].id} ${duration}s cubic-bezier(0.190, 1.000, 0.220, 1.000) both infinite`

    Renderer.updateElementStyle($elem, 'animation', animation);
    store.dispatch(actions.updateElementAttribute('animation', animation));
  }

  function wipe() {
    resetAnimation();
    const $elem = util.getElementContent(store.getState().$element);

    let duration = 2;

    util.createAnimation($elem, 'wipe')

    const animation = `wipe_${$elem[0].id} ${duration}s cubic-bezier(0.190, 1.000, 0.220, 1.000) both infinite`

    Renderer.updateElementStyle($elem, 'animation', animation);
    store.dispatch(actions.updateElementAttribute('animation', animation));
  }

  function breathe() {
    resetAnimation();
    const $elem = util.getElementContent(store.getState().$element);

    let duration = 2;

    util.createAnimation($elem, 'breathe')

    const animation = `breathe_${$elem[0].id} ${duration}s cubic-bezier(0.190, 1.000, 0.220, 1.000) both infinite`

    Renderer.updateElementStyle($elem, 'animation', animation);
    store.dispatch(actions.updateElementAttribute('animation', animation));
  }

  function pop() {
    resetAnimation();
    const $elem = util.getElementContent(store.getState().$element);

    let duration = 1;

    util.createAnimation($elem, 'pop')

    const animation = `pop_${$elem[0].id} ${duration}s cubic-bezier(0.190, 1.000, 0.220, 1.000) both infinite`

    Renderer.updateElementStyle($elem, 'animation', animation);
    store.dispatch(actions.updateElementAttribute('animation', animation));
  }

  function fade() {
    resetAnimation();
    const $elem = util.getElementContent(store.getState().$element);

    let duration = 2;

    util.createAnimation($elem, 'fade')

    const animation = `fade_${$elem[0].id} ${duration}s infinite`

    Renderer.updateElementStyle($elem, 'animation', animation);
    store.dispatch(actions.updateElementAttribute('animation', animation));
  }

  return (
    <div className="scroller no-top">
      <div id="app-aside-video-adjusts">
        <h3>Adjustments</h3>
        <hr />

        <ul className="slider-list">
          <li className="slider-item">
            <div className={'slider-wrap'}>
              <label>Brightness</label>
              <div className="toolbar-wrap">
                <input className="slider" type="range" min="0" max="100" step="1" value={store.getState().brightness / 2} onChange={updateBrightness} />
              </div>
              <input className="value" type="number" min="0" max="100" step="1" disabled={true} value={Math.round(store.getState().brightness / 2)} />
            </div>
          </li>

          <li className="slider-item">
            <div className={'slider-wrap'}>
              <label>Contrast</label>
              <div className="toolbar-wrap">
                <input className="slider" type="range" min="0" max="100" step="1" value={store.getState().contrast / 2} onChange={updateContrast} />
              </div>
              <input className="value" type="number" min="0" max="100" step="1" disabled={true} value={Math.round(store.getState().contrast / 2)} />
            </div>
          </li>

          <li className="slider-item">
            <div className={'slider-wrap'}>
              <label>Saturation</label>
              <div className="toolbar-wrap">
                <input className="slider" type="range" min="0" max="100" step="1" value={store.getState().saturation / 2} onChange={updateSaturation} />
              </div>
              <input className="value" type="number" min="0" max="100" step="1" disabled={true} value={Math.round(store.getState().saturation / 2)} />
            </div>
          </li>

          <li className="slider-item">
            <div className={'slider-wrap'}>
              <label>Blur</label>
              <div className="toolbar-wrap">
                <input className="slider" type="range" min="0" max="100" step="1" value={store.getState().blur * 10} onChange={updateBlur} />
              </div>
              <input className="value" type="number" min="0" max="100" step="1" disabled={true} value={Math.round(store.getState().blur * 10)} />
            </div>
          </li>
        </ul>

        {/* <h3 style="margin-top: 20px;">Color Tint</h3>
      <hr />

      <ul className="slider-list">
        <li className="slider-item">
          <div className={'slider-wrap'}>
            <label>Color</label>

          </div>
        </li>

        <li className="slider-item">
          <div className={'slider-wrap'}>
            <label>Opacity</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="0" max="100" step="1" value={store.getState().opacity} onChange={updateOpacity} />
            </div>
            <input className="value" type="number" min="0" max="100" step="1" disabled={true} value={Math.round(store.getState().opacity)} />
          </div>
        </li>
      </ul> */}

        <h3>Effects</h3>
        <hr />

        <div className="effects">
          <div className="effect">
            <span>Black & White</span>
            <Switch checked={store.getState().grayscale == 1 ? true : false} onChange={toggleGrayscale} />
          </div>

          <div className="effect">
            <span>Sepia</span>
            <Switch checked={store.getState().sepia == 1 ? true : false} onChange={toggleSepia} />
          </div>

          <div className="effect">
            <span>Invert</span>
            <Switch checked={store.getState().invert == 1 ? true : false} onChange={toggleInvert} />
          </div>
        </div>

        {/* <h3>Animations</h3>
        <hr />

        <div className="animations">
          <div onClick={rise}>
            <a>
              <span className="icon">
                <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-rise-icon"} /></svg>
              </span>
              <h6>Rise</h6>
            </a>
          </div>

          <div onClick={pan}>
            <a>
              <span className="icon">
                <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-pan-icon"} /></svg>
              </span>
              <h6>Pan</h6>
            </a>
          </div>

          <div onClick={wipe}>
            <a>
              <span className="icon">
                <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-wipe-icon"} /></svg>
              </span>
              <h6>Wipe</h6>
            </a>
          </div>

          <div onClick={breathe}>
            <a>
              <span className="icon">
                <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-breathe-icon"} /></svg>
              </span>
              <h6>Breathe</h6>
            </a>
          </div>

          <div onClick={pop}>
            <a>
              <span className="icon">
                <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-pop-icon"} /></svg>
              </span>
              <h6>Pop</h6>
            </a>
          </div>

          <div onClick={fade}>
            <a>
              <span className="icon">
                <svg viewBox="0 0 35 27">
                  <g clip-path="url(#mrhli5jyja)" fill="#333">
                    <path d="M32.91.5H1.22C.54.5 0 1.03 0 1.69v23.86c0 .66.54 1.19 1.22 1.19h31.69c.67 0 1.22-.53 1.22-1.19V1.69c0-.66-.54-1.19-1.22-1.19zm-1.52 23.57H2.74v-1.49l5.27-6.13 5.72 6.64 8.89-10.32 8.76 10.16v1.13l.01.01zm0-4.84-8.52-9.9a.304.304 0 0 0-.46 0l-8.66 10.05-5.48-6.36a.304.304 0 0 0-.46 0l-5.04 5.85V3.18h28.64v16.04l-.02.01zM9.15 11.54c.44 0 .88-.08 1.28-.25a3.35 3.35 0 0 0 1.82-1.77 3.193 3.193 0 0 0 0-2.52c-.17-.4-.42-.76-.73-1.06-.31-.3-.68-.55-1.09-.71-.41-.16-.84-.25-1.28-.25-.89 0-1.74.35-2.37.96-.63.62-.98 1.45-.98 2.32 0 .87.35 1.7.98 2.32.63.62 1.48.96 2.37.96zm0-4.33c.59 0 1.07.47 1.07 1.04 0 .57-.48 1.04-1.07 1.04-.59 0-1.07-.47-1.07-1.04 0-.57.48-1.04 1.07-1.04z" fill="url(#vqlsurc59b)" />
                  </g>
                  <defs>
                    <linearGradient id="vqlsurc59b" x1="17.06" y1="26.75" x2="17.06" y2=".5" gradientUnits="userSpaceOnUse">
                      <stop offset=".09" stop-color="#333" stop-opacity="0" />
                      <stop offset=".17" stop-color="#333" stop-opacity=".11" />
                      <stop offset=".71" stop-color="#333" stop-opacity=".75" />
                      <stop offset="1" stop-color="#333" />
                    </linearGradient>
                    <clipPath id="mrhli5jyja">
                      <path fill="#ccc" transform="translate(0 .5)" d="M0 0h34.12v26.25H0z" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <h6>Fade</h6>
            </a>
          </div>
        </div> */}
      </div>
    </div>
  )
}
